'use client';

import { useNavigate } from 'react-router-dom';

import { SearchMenu } from '@zoomit/icons';
import { Sheet } from '@zoomit/mobile-sheet';
import { IconButton } from '@zoomit/primitives';
import { OriginURL } from '@zoomit/web-kit';
import { cssVar, theme } from '@zoomit/zoomit-ds';

import { useWebKitCustomization } from '../../../hooks/useWebKitCustomization';
import type { MenuParserData } from '../../../types/menus';
import DefaultMenuAvatarMobile from './DefaultMenuMobileAvatar';
import DefaultMenuMobileRoutes from './DefaultMenuMobileRoutes';
import { useDefaultMenuContext } from './DefaultMenuModuleProvider';

type Props = {
  searchInstanceRenderer?: MenuParserData['searchInstanceRenderer'];
};

const DefaultMenuMobile = (props: Props) => {
  const { searchInstanceRenderer } = props;
  const { mobileMenuTriggerState, initialEntry } = useDefaultMenuContext();
  const navigate = useNavigate();
  const basePath = useWebKitCustomization((settings) => settings.basePath);
  const tenantLogoRenderer = useWebKitCustomization((settings) => settings.tenantLogoRenderer);

  return (
    <>
      <header
        className={
          'bg-black1 sticky top-0 z-[100] flex h-[58px] w-full items-center justify-between px-4 py-[13px] transition-all duration-200 lg:hidden'
        }
        data-testid="menu-mobile"
      >
        <IconButton onClick={mobileMenuTriggerState.open}>
          <SearchMenu fill={cssVar(theme.white)} size="lg" />
        </IconButton>

        <a href={`${OriginURL}/${basePath}`} style={{ display: 'flex', textDecoration: 'none' }}>
          {tenantLogoRenderer({ fill: cssVar(theme.white) })}
        </a>

        <DefaultMenuAvatarMobile
          onProfileClick={mobileMenuTriggerState.open}
          Logo={() => tenantLogoRenderer({ fill: cssVar(theme.white) })}
        />
      </header>

      {mobileMenuTriggerState.isOpen && (
        <Sheet
          className={'md:w-1/2 lg:hidden'}
          isOpen={mobileMenuTriggerState.isOpen}
          onClose={mobileMenuTriggerState.close}
          disableDrag
        >
          <Sheet.Container
            isFullScreen
            hasBorderRadius={false}
            style={{ backgroundColor: `${cssVar(theme.background2)}` }}
          >
            <Sheet.Content>
              <DefaultMenuMobileRoutes
                searchInstanceRenderer={searchInstanceRenderer}
                onCloseMenu={() => {
                  mobileMenuTriggerState.close();
                  navigate(initialEntry);
                }}
              />
            </Sheet.Content>
          </Sheet.Container>
          <Sheet.Backdrop />
        </Sheet>
      )}
    </>
  );
};

export default DefaultMenuMobile;
